import { __require as requireWithSelector } from "../node_modules/use-sync-external-store/shim/with-selector.mjs";
var withSelectorExports = requireWithSelector();
export {
  withSelectorExports as w
};
//# sourceMappingURL=with-selector.mjs.map
